import React from 'react';
import Helpers from '../../common/Helpers'
import { LanguageCode } from "../../common/Conf"
const Cookies = require('js-cookie');

interface Props { }

function LanguagesSwitch(props: Props) {
    const [menuOpen, setMenuOpen] = React.useState(false)

    function onLanguageClick(e: any) {
        e.preventDefault();
        Cookies.set("rc_culture", e.currentTarget.dataset.value);
        Helpers.PageReload('');
    }

    function onMenuClick(e: any) {
        e.preventDefault();
        setMenuOpen(true);
    }

    const languages = Helpers.Languages();

    return (
        <div className="content-menu-lns">
            <div className={" " + (menuOpen ? "hidden" : "pointer")} onClick={onMenuClick}>
                <img src={"/flags/" + LanguageCode + ".svg"} alt="" />
            </div>
            {menuOpen && <ul className="content-menu-lns-list">
                {languages.map((item, index) => (
                    <li className="menu-item" onClick={onLanguageClick} data-value={item.code} key={index}>
                        <img src={"/flags/" + item.code + ".svg"} alt="" />
                        <div>{item.name}</div>
                    </li>
                ))}

            </ul>}
        </div>
    )
}
export default LanguagesSwitch;